import { metricsLogger } from '@frontend/tracking';

export type CacheOutcome = 'hit-fresh' | 'hit-stale' | 'miss';

/**
 * Tracks and reports cache hits, misses, and revalidations to telemetry.
 */
export function trackCacheMetric(queryKey: unknown, outcome: CacheOutcome) {
  try {
    let formattedKey = Array.isArray(queryKey)
      ? queryKey
          .map((part) => (typeof part === 'object' && part !== null ? JSON.stringify(part) : String(part)))
          .join('|')
      : typeof queryKey === 'string'
      ? queryKey
      : JSON.stringify(queryKey);

    const GUID_REGEX = /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi;
    formattedKey = formattedKey.replace(GUID_REGEX, '<guid>');

    metricsLogger.metric('query_cache_outcome', 1, {
      attributes: {
        queryKey: formattedKey,
        outcome,
        team: 'frontend-ops',
        category: 'infra',
      },
    });
  } catch (err) {
    // Avoid crashing the core application due to telemetry or serialization errors
    console.error('Error tracking query cache outcome metric', err);
  }
}
